import { lazyLoad } from 'utils/loadable';

export const TwoFactorAuthentication = lazyLoad(
  () => import('./twoFactorAuthentication.page'),
  (module) => module.TwoFactorAuthentication
);
